const DEALS = [
  { store: 'Artisan Coffee', discount: '50% off', distance: '0.3 km', time: '4:32' },
  { store: 'Urban Sneaker Co.', discount: '40% off', distance: '0.8 km', time: '12:05' },
  { store: 'Bloom Florals', discount: '35% off', distance: '1.2 km', time: '8:15' },
  { store: 'The Bagel Shop', discount: '45% off', distance: '0.5 km', time: '2:48' },
  { store: 'Vintage Vinyl', discount: '30% off', distance: '2.0 km', time: '18:33' },
  { store: 'Fresh Smoothie Bar', discount: '50% off', distance: '0.2 km', time: '3:10' },
  { store: 'Board Game Cafe', discount: '25% off', distance: '1.5 km', time: '22:00' },
  { store: 'Pasta Place', discount: '40% off', distance: '0.6 km', time: '6:45' },
];

function TickerCard({ store, discount, distance, time }: typeof DEALS[number]) {
  return (
    <div className="flex flex-shrink-0 items-center gap-3 rounded-xl border border-gray-200 bg-white px-5 py-3 whitespace-nowrap">
      <span className="text-sm font-bold text-gray-800">{store}</span>
      <span className="rounded-full bg-brand-50 px-2.5 py-0.5 text-xs font-bold text-brand-600">
        {discount}
      </span>
      <span className="text-xs text-gray-400">{distance}</span>
      <span className="text-xs tabular-nums text-gray-400">{time} left</span>
    </div>
  );
}

export function DealTicker() {
  const doubled = [...DEALS, ...DEALS];

  return (
    <section className="overflow-hidden py-8">
      <p className="mb-4 text-center text-xs font-semibold uppercase tracking-wider text-gray-400">
        Deals happening right now
      </p>
      <div className="relative">
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-20 bg-gradient-to-r from-white to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-20 bg-gradient-to-l from-white to-transparent" />
        <div className="motion-safe:animate-[scroll_30s_linear_infinite] flex gap-4" style={{ width: 'max-content' }}>
          {doubled.map((deal, i) => (
            <TickerCard key={i} {...deal} />
          ))}
        </div>
      </div>
    </section>
  );
}
